<div
  [formGroup]="form"
  class="form -question"
  [ngClass]="question.required ? '-asterisk' : ''"
  [class.is-invalid]="!isValid && (isDirty || isTouched)"
  [class.is-valid]="isValid && (isDirty || isTouched)">
  <label>
    <span class="-fontMedium" [ngClass]="question.disabled ? '-fontMedium -disabled-label' : '-fontMedium'">
      {{ question.label }}
      <!-- <span *ngIf="!question.required">
      (Optional)
    </span> -->
    </span>
    @if (question.help) {
    <span class="-fontMedium" class="form -help">{{ question.help }}</span>
    } @switch (question.type) {
    <!-- <input *ngSwitchCase="'text'" [type]="question.type" [formControlName]="question.key" [id]="question.key" (mouseenter)="showTooltip($event)" (mouseleave)="clearTooltip()"/> -->
    @case ('text') {
    <input
      [readonly]="question.disabled ? true : false"
      [class.-disabled]="question.disabled"
      [type]="question.type"
      [formControlName]="question.key"
      [name]="question.key"
      [id]="question.key"
      [required]="question.required"
      [placeholder]="question.placeholder ? question.placeholder : ''"
      [ngClass]="{ error: !isValid && (isDirty || isTouched) }"
      [minlength]="question.minlength"
      [maxlength]="question.maxlength" />
    } @case ('password') {
    <input
      type="password"
      [autocomplete]="question.autocomplete ? question.autocomplete : 'off'"
      [readonly]="question.disabled ? true : false"
      [class.-disabled]="question.disabled"
      [formControlName]="question.key"
      [name]="question.key"
      [id]="question.key"
      [ngClass]="{ error: !isValid && (isDirty || isTouched) }"
      [required]="question.required"
      [placeholder]="question.placeholder || ''" />
    } @case ('date') {
    <input
      [readonly]="question.disabled ? true : false"
      [class.-disabled]="question.disabled"
      [type]="question.type"
      [formControlName]="question.key"
      [name]="question.key"
      [id]="question.key"
      [required]="question.required" />
    } @case ('email') {
    <input
      [placeholder]="question.placeholder"
      [readonly]="question.disabled ? true : false"
      [class.-disabled]="question.disabled"
      [type]="question.type"
      [formControlName]="question.key"
      [name]="question.key"
      [id]="question.key"
      [ngClass]="{ error: !isValid && (isDirty || isTouched) }"
      [required]="question.required"
      [maxlength]="question.maxlength" />
    } @case ('number') {
    <input
      [readonly]="question.disabled ? true : false"
      [class.-disabled]="question.disabled"
      [type]="question.type"
      [formControlName]="question.key"
      [name]="question.key"
      [id]="question.key"
      [required]="question.required" />
    } @case ('tel') {
    <input
      [readonly]="question.disabled ? true : false"
      [class.-disabled]="question.disabled"
      [type]="question.type"
      [formControlName]="question.key"
      [id]="question.key"
      [name]="question.key"
      [required]="question.required" />
    } @case ('textarea') {
    <textarea
      [readonly]="question.disabled ? true : false"
      [class.-disabled]="question.disabled"
      [id]="question.key"
      [name]="question.key"
      [placeholder]="question.placeholder ? question.placeholder : ''"
      [ngClass]="{ error: !isValid && (isDirty || isTouched) }"
      [formControlName]="question.key"
      [minlength]="question.minlength"
      [maxlength]="question.maxlength"
      [required]="question.required">
    </textarea>
    } @case ('select') {
    <select [formControlName]="question.key">
      <option value="">-- Please Choose --</option>
      @for (option of question.options; track option) {
      <option [value]="option.value">{{ option.label }}</option>
      }
    </select>
    } }

    <!-- <tooltip
  *ngIf="!_tooltipClosed && question.help"
  [location]="_tooltipLocation"
  class="-colorAccentDarkTeal">
  {{ question.help }}
</tooltip> -->

    <!-- <tooltip
*ngIf="!_tooltipClosed && !isValid && (isDirty || isTouched)"
[location]="_tooltipLocation"
[svgChar]="_svgChar"
class="-colorAccentDarkTeal">
{{ question.label }} is required
</tooltip> -->

    @if (!isValid && (isDirty || isTouched)) {
    <span class="form -error">
      @if (question.customErrorMessage) {
      <span>
        {{ question.customErrorMessage }}
      </span>
      } @if (!question.customErrorMessage && (errors.required || errors['whitespace']) && question.type !== 'email') {
      <span> Please fill in this field. {{ question.label }} is required </span>
      } @if (!question.customErrorMessage && (errors['invalidname']) && ['name', 'family_name', 'first_name',
      'last_name', 'title', 'company'].includes(question.key)) {
      <span> {{ question.label }} has invalid special characters. </span>
      } @if (!question.customErrorMessage && errors && question.type === 'email') {
      <span> Please fill in a valid company email address. E.g. name&#64;business.com </span>
      } @if (!question.customErrorMessage && errors && question.key === 'phone') {
      <span> Please fill in a valid phone number. E.g. +19997778888 </span>
      } @if (!question.customErrorMessage && errors && question.key === 'Description_Hidden__c') {
      <span> {{ question.label }} has invalid special characters. </span>
      }
      <!-- <span *ngIf="!question.customErrorMessage && errors.pattern && question.type !== 'password'">
    Please enter the expected input.
  </span> -->
    </span>
    }
  </label>
</div>
